module.exports = __webpack_public_path__ + "static/media/doc.b495e55e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/doc.png
// module id = 233
// module chunks = 0